import React from 'react';
import ReactDOM from 'react-dom/client';
// Only the icons the site uses; regenerated by scripts/build-icon-subset.js before start/build.
import './css/bootstrap-icons-subset.css';
import './index.css';
import './App.css';
import './Media.css';
import App from './App';
import { preloadRoute } from './components/routes';
import { keepSeoTagsAfterTitle } from './utils/seo';

keepSeoTagsAfterTitle();

// Load the landing page's code first so the app renders the full page in one pass.
// Pages are prerendered to static HTML at build time (scripts/prerender.js); React
// then replaces that HTML with an identical live tree, so there is no visible change.
preloadRoute(window.location.pathname)
  .catch(() => {})
  .then(() => {
    // No <React.StrictMode>: its dev-only mount/unmount/remount makes react-helmet
    // drop every page's meta description, keywords and canonical (title survives).
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(<App />);
  });